module.exports = __webpack_public_path__ + "img/bg37.dfe0837c.png";